__turbopack_context__.v({
  "description": "TltHoW_description",
  "form": "TltHoW_form",
  "input": "TltHoW_input",
  "paper": "TltHoW_paper",
  "title": "TltHoW_title",
  "wrapper": "TltHoW_wrapper",
});
